module.exports = __webpack_public_path__ + "img/hotview.975f8421.png";